import { MINUS } from '../number/fixed';
import { formatCompactUsd, type CompactUsdOptions } from './compact-usd';

/**
 * `formatCompactUsd` with its direction on the front: a true minus below
 * zero ("−$450"), and with `plus` a "+" on zero and above ("+$1.2M") for a
 * figure a reader compares by sign. The sign is decided on the value
 * (`value < 0`), the figure on its magnitude.
 */
export function formatSignedCompactUsd(
  value: number,
  { plus = false, ...options }: CompactUsdOptions & { plus?: boolean } = {}
): string {
  const magnitude = formatCompactUsd(Math.abs(value), options);
  return `${value < 0 ? MINUS : plus ? '+' : ''}${magnitude}`;
}
